export default __webpack_public_path__ + "static/media/ManagerSafetyWlk.9b0f926c.png";